import PropTypes from 'prop-types';

const propTypes = {
	value: PropTypes.bool,
};

export default propTypes;
